import React, { useState } from 'react';
import { useAuth } from '@/App';
import { PageHeader } from '@/components/ModernUI';
import { DataHistoryPanel, DataHistorySummary } from '@/components/DataHistory';
import { Database, History } from 'lucide-react';

/**
 * Data History Page
 * 
 * Provides a comprehensive view of all data history across the system.
 * Includes timeline view, audit logs, and archive/restore functionality.
 */
export default function DataHistoryPage() {
  const { user } = useAuth();
  const [selectedCategory, setSelectedCategory] = useState(null);
  
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  const categories = [
    { id: 'census', title: 'Census & Admissions' },
    { id: 'clinical', title: 'Clinical Quality' },
    { id: 'financial', title: 'Financial Data' },
    { id: 'compliance', title: 'Compliance' },
    { id: 'workforce', title: 'Staff Productivity' },
    { id: 'program', title: 'Program Overview' }
  ];

  return (
    <div className="space-y-6" data-testid="data-history-page">
      <PageHeader
        icon={History}
        title="Data History"
        subtitle="View timeline of data entries, audit logs, and manage archived records"
        gradient="from-[#00b0ab] via-[#009590] to-[#48494b]"
      />

      {/* Summary Overview */}
      <DataHistorySummary onCategorySelect={setSelectedCategory} />

      {/* Category History Panels */}
      <div className="space-y-4">
        <h2 className="text-lg font-semibold flex items-center gap-2">
          <Database className="h-5 w-5" />
          Data Categories
        </h2>
        
        <div className="grid gap-4">
          {categories.map(cat => (
            <DataHistoryPanel
              key={cat.id}
              category={cat.id}
              title={cat.title}
              defaultExpanded={selectedCategory === cat.id}
              showAuditLog={true}
              isAdmin={isAdmin}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
